import { editSuperAdmin } from 'actions/profile';
import { Modal } from 'antd';
import { Button } from 'components/Button';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import imagePath from '../../Assets/userManagementV3/confirmModalPic.png';
import { CloseOutlined } from "@ant-design/icons";

const SaveUserBasicProfileV3 = ({ saveConfirmationModal, onCancel, handleOk, setFlag, flag, onDeleteConfirm
}) => {
  const [saveButtonLoader, setSaveButtonLoader] = useState(false);

  const history = useHistory();

  return (
    <Modal
      className="modal-round-corner"
      centered
      visible={saveConfirmationModal}
      onOk={flag ? onDeleteConfirm:handleOk}
      onCancel={onCancel}
      header={null}
      footer={null}
      width={450}
      closeIcon={<CloseOutlined style={{fontSize: 20,color: "#AEAEAE",fontWeight: 600, paddingTop: 20, paddingRight: 10 }}/>}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "25px",
        }}
      >
        <div><img src={imagePath} alt="" /></div>
        <div
          style={{ fontSize: "24px", fontWeight: 500 }}
        >
          Confirm
        </div>
        <div
          style={{
            fontSize: "16px",
            color: "#636363",
            marginTop: "10px",
            textAlign: 'center'
          }}
        >
          {flag ? "Are you sure you want to remove the profile photo ?" : "Are you sure you want to save the changes ?"}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-evenly",
          marginTop: "30px",
        }}
      >
        <div>
          <Button
            type='primary'
            onClick={onCancel}
            style={{ marginRight: 20, backgroundColor: "#FFFFFF", color: "#AEAEAE" }}
          >
            <div
            >
              NO
            </div>
          </Button>
        </div>
        <div>
          <Button
            type="primary"
            loading={saveButtonLoader}
            onClick={() => {
              setSaveButtonLoader(true);

              if (flag) {  
                onDeleteConfirm(() => setSaveButtonLoader(false), onCancel);
              } else {
                handleOk(onCancel, () => setSaveButtonLoader(false));
              }
            }}
          >
            YES
          </Button>
        </div>
      </div>
    </Modal>
  );
}


const mapStateToProps = (state) => {
  return {}
}

const mapDispatchToProps = (dispatch) => ({

})


export default connect(mapStateToProps, mapDispatchToProps)(SaveUserBasicProfileV3);
